import React from 'react'
import { Link, LinkProps } from 'react-router'
import Typography from './Typography'
import TooltipWrapper from './TooltipWrapper'

interface NavLinkProps extends LinkProps {
  icon?: React.ReactNode
  isActive?: boolean
  isCollapsed?: boolean
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

const NavLink: React.FC<NavLinkProps> = ({
  icon,
  isActive = false,
  isCollapsed = false,
  children,
  className = '',
  onClick,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault()
      onClick(e)
    }
  }

  const content = (
    <Link
      className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'}  p-4 transition-colors ${
        isActive ? 'border-l-2  border-orange-500 bg-gray-700' : 'text-gray-50 hover:border-l-2 hover:border-gray-50'
      } ${className}`}
      onClick={handleClick}
      {...props}
    >
      {icon}
      {!isCollapsed && <Typography variant={isActive ? 'sm-bold' : 'sm'}>{children}</Typography>}
    </Link>
  )

  if (isCollapsed) {
    return (
      <TooltipWrapper content={children} side="right">
        {content}
      </TooltipWrapper>
    )
  }

  return content
}

export default NavLink
